import React, { useState } from 'react';
import '../styles/second.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Second() {
  // State for contact popup
  const [showContact, setShowContact] = useState(false);

  return (
    <>
      <div className="container my-5">
        <div className="row">
          {/* Course Description */}
          <div className="col-lg-8">
            <h2 className="mb-4 fw-bold">Advanced Technology Academy Programs Overview</h2>
            <p>
              Our Advanced Technology Academy  is powered by elite instructors from IIT alumni with years of in-depth 
              experience in energy sector programming and quantum computing AI & ML ,BlockChain,Cloud Technologies, Full stack AI Web 3.0 and Mobile App Development based on Product & services Model. We specialize in quantum-driven AI algorithms, 
              quantum cloud computing, and other future-demanding technologies serving multiple industries.
            </p>
            <h3 className="mt-5">Program Features</h3>
            <div className="row mt-3">
              {/* Key Features List */}
              <div className="col-md-6 mb-3">
                <p className="d-flex align-items-start">
                  <span className="me-2 text-primary">
                    <i className="bi bi-check-circle"></i>
                  </span>
                  Comprehensive IIT-JEE and engineering entrance exam preparation by IIT alumni
                </p>
                <p className="d-flex align-items-start">
                  <span className="me-2 text-primary">
                    <i className="bi bi-check-circle"></i>
                  </span>
                  UG/PG abroad admission training with specialized guidance for top universities
                </p>
                <p className="d-flex align-items-start">
                  <span className="me-2 text-primary">
                    <i className="bi bi-check-circle"></i>
                  </span>
                  Advanced energy sector sciences training with practical laboratory sessions
                </p>
              </div>
              <div className="col-md-6">
                <p className="d-flex align-items-start">
                  <span className="me-2 text-primary">
                    <i className="bi bi-check-circle"></i>
                  </span>
                  Paid internship opportunities with our industry partners in AI and quantum computing
                </p>
                <p className="d-flex align-items-start">
                  <span className="me-2 text-primary">
                    <i className="bi bi-check-circle"></i>
                  </span>
                  Real-world application development training in AI, blockchain, and energy sector technologies
                </p>
                <p className="d-flex align-items-start">
                  <span className="me-2 text-primary">
                    <i className="bi bi-check-circle"></i>
                  </span>
                  Full Stack Development with career support and guaranteed job assistance for top performers
                </p>
              </div>
            </div>
          </div>

          {/* Enrollment Section */}
          <div className="col-lg-4">
            <div className="p-3 bg-light border rounded">
              <h4 className="mb-4">Program Fee </h4>
              <h5 className="text-primary"> Starts From ₹ 2000/- <p className='text-muted fs-6'>Month</p></h5>
              <p>(Incl. taxes)</p>
              <button className=" bg-primary  w-100 mb-3"> <a className="fw-bold text-white" href="/enroll"> Enroll Now</a> </button>
              <p className="small text-muted">
                * You are enrolling for Cohort Training Starting on 15 May.
                <a href="/">Here</a>
              </p>
              <hr />
              <h5 className="mt-4">Education Model</h5>
              <p className="small">Our courses are based on the STEM+E model:</p>
              <ul className="small">
                <li>Science</li>
                <li>Technology</li>
                <li>Engineering</li>
                <li>Mathematics</li>
                <li>+ Entrepreneurship</li>
              </ul>
              <button onClick={() => setShowContact(true)} className="btn btn-primary w-100">
                <i className="bi bi-info-circle"></i> CONTACT ACADEMY
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Contact Popup */}
      {showContact && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
          <div className="bg-white p-4 rounded shadow" style={{ maxWidth: '500px', width: '90%' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="m-0">Contact Information</h4>
              <button onClick={() => setShowContact(false)} className="btn-close"></button>
            </div>
            <hr />
            <div className="mb-3">
              <p><strong><i className="bi bi-envelope"></i> Email:</strong> info@olewinacademy.com</p>
              <p><strong><i className="bi bi-telephone"></i> Phone:</strong> +91-8639449423</p>
              <p><strong><i className="bi bi-envelope"></i> Gmail:- </strong>olewinacademy@gmail.com </p>
            </div>
            <div className="mb-3">
              <h5>Programs Offered:</h5>
              <ul>
                <li>IIT - JEE (Mains & Advance) & Engineering Entrance Preparation</li>
                <li>NEET - UG & PG  & Medical Entrance Preparation (MBBS)</li>
                <li>Abroad University Admission Training</li>
                <li>Quantum Computing & AI Development</li>
                <li>Energy Sector Technologies</li>
                <li>Blockchain Development</li>
                <li>Full Stack Developer Web 3.0</li>
                <li>Full Stack web /Mobile App Developer</li>
                <li>Business & Marketing Programs </li>
                <li>And On Demand Programs for Future Ready skills </li>
                
              </ul>
            </div>
            <button onClick={() => setShowContact(false)} className="btn btn-primary w-100">Close</button>
          </div>
        </div>
      )}
    </>
  );
}

export default Second;